import type {TableConfiguration} from 'schema/table/types';
import type {AgentPerson} from 'services/agent/types';
import {defaultTableConfig} from 'schema/table/configuration/defaultTableConfig';
import {eventAgentDefaultColumns} from './columns';

export const eventAgentTableConfig: TableConfiguration<AgentPerson> = {
  ...defaultTableConfig,
  defaultColumns: eventAgentDefaultColumns,
};
